(()=>{'use strict';
const FALLBACK=[
  'https://cdn.shopify.com/videos/c/vp/543406daf7ad4d708148665017a222bb/543406daf7ad4d708148665017a222bb.HD-720p-3.0Mbps-91024719.mp4',
  'https://cdn.shopify.com/videos/c/vp/2bc850f3fb4449e0a931f461d6d5d382/2bc850f3fb4449e0a931f461d6d5d382.HD-720p-1.6Mbps-91021840.mp4',
  'https://cdn.shopify.com/videos/c/vp/1e6341a13c424de48f4cf746dcb485da/1e6341a13c424de48f4cf746dcb485da.HD-720p-1.6Mbps-91019755.mp4'
];

const videoSource=video=>{
  if(!video)return '';
  const sources=[...video.querySelectorAll('source')];
  const mp4=sources.find(source=>(source.type||'').toLowerCase().includes('mp4'));
  return mp4?.src||sources[0]?.src||video.currentSrc||video.src||'';
};

const collectSources=()=>{
  const sources=[];
  document.querySelectorAll('#roar-videos .lr-video-media video').forEach(video=>{
    const src=videoSource(video);
    if(src&&!sources.includes(src))sources.push(src);
  });
  if(sources.length<3){
    FALLBACK.forEach(src=>{
      if(sources.length<3&&!sources.includes(src))sources.push(src);
    });
  }
  return sources;
};

function init(){
  const host=document.querySelector('.little-roar-page .hero-media');
  if(!host||host.dataset.lrHeroReels==='1')return;
  const sources=collectSources();
  if(sources.length<3)return;

  host.dataset.lrHeroReels='1';
  host.classList.add('lr-hero-reels-host');

  const carousel=document.createElement('div');
  carousel.className='lr-hero-reels';
  carousel.tabIndex=0;
  carousel.setAttribute('role','region');
  carousel.setAttribute('aria-roledescription','carousel');
  carousel.setAttribute('aria-label','Little Roar videos. Swipe to change video.');

  const stage=document.createElement('div');
  stage.className='lr-hero-reels-stage';
  carousel.appendChild(stage);

  const total=sources.length;
  sources.forEach((src,index)=>{
    const card=document.createElement('div');
    card.className='lr-hero-reel-card';
    card.dataset.lrHeroReel=String(index);
    card.setAttribute('role','button');
    card.setAttribute('aria-label',`Show video ${index+1} of ${total}`);

    const video=document.createElement('video');
    video.className='lr-hero-reel-video';
    video.src=src;
    video.autoplay=true;
    video.defaultMuted=true;
    video.muted=true;
    video.loop=true;
    video.playsInline=true;
    video.preload='auto';
    video.setAttribute('muted','');
    video.setAttribute('autoplay','');
    video.setAttribute('playsinline','');
    video.setAttribute('webkit-playsinline','');
    video.setAttribute('disablepictureinpicture','');
    video.setAttribute('aria-hidden','true');

    card.appendChild(video);
    stage.appendChild(card);
  });

  host.replaceChildren(carousel);

  const cards=[...stage.querySelectorAll('.lr-hero-reel-card')];
  const videos=[...stage.querySelectorAll('video')];
  let active=0;
  let startX=0;
  let startY=0;
  let tracking=false;
  let lastSwipe=0;
  let soundUnlocked=false;
  let heroVisible=false;

  const detectInitialVisibility=()=>{
    const rect=host.getBoundingClientRect();
    const viewport=window.innerHeight||document.documentElement.clientHeight;
    heroVisible=rect.bottom>viewport*.18&&rect.top<viewport*.82&&!document.hidden;
  };

  const safePlay=video=>{
    const promise=video.play();
    if(promise?.catch)promise.catch(()=>{});
  };

  const visibleIndexes=()=>{
    const total=cards.length;
    return new Set([(active-1+total)%total,active,(active+1)%total]);
  };

  const syncPlayback=()=>{
    if(!heroVisible||document.hidden){
      videos.forEach(video=>{
        video.pause();
        video.muted=true;
      });
      return;
    }

    const visible=visibleIndexes();
    videos.forEach((video,index)=>{
      if(!visible.has(index)){
        video.pause();
        video.muted=true;
        return;
      }
      const isCenter=index===active;
      video.muted=isCenter?!soundUnlocked:true;
      safePlay(video);
    });
  };

  const unlockSound=()=>{
    soundUnlocked=true;
    if(!heroVisible||document.hidden)return;
    const video=videos[active];
    if(!video)return;
    video.muted=false;
    const promise=video.play();
    if(promise?.catch){
      promise.catch(()=>{
        video.muted=true;
        safePlay(video);
      });
    }
  };

  const render=()=>{
    const total=cards.length;
    const prev=(active-1+total)%total;
    const next=(active+1)%total;
    cards.forEach((card,index)=>{
      const isCenter=index===active;
      const isLeft=index===prev;
      const isRight=index===next;
      const isVisible=isCenter||isLeft||isRight;
      card.classList.toggle('is-center',isCenter);
      card.classList.toggle('is-left',isLeft);
      card.classList.toggle('is-right',isRight);
      card.hidden=!isVisible;
      card.style.display=isVisible?'':'none';
      card.tabIndex=isCenter?0:-1;
      card.setAttribute('aria-current',isCenter?'true':'false');
    });
    syncPlayback();
  };

  const move=direction=>{
    const total=cards.length;
    active=(active+(direction>0?1:-1)+total)%total;
    render();
  };

  carousel.addEventListener('pointerdown',event=>{
    if(event.pointerType==='mouse'&&event.button!==0)return;
    unlockSound();
    tracking=true;
    startX=event.clientX;
    startY=event.clientY;
    carousel.classList.add('is-dragging');
    try{carousel.setPointerCapture(event.pointerId)}catch(_error){}
  });

  carousel.addEventListener('pointerup',event=>{
    if(!tracking)return;
    tracking=false;
    carousel.classList.remove('is-dragging');
    const dx=event.clientX-startX;
    const dy=event.clientY-startY;
    if(Math.abs(dx)>=38&&Math.abs(dx)>Math.abs(dy)*1.15){
      lastSwipe=Date.now();
      move(dx<0?1:-1);
    }
  });

  carousel.addEventListener('pointercancel',()=>{
    tracking=false;
    carousel.classList.remove('is-dragging');
  });

  carousel.addEventListener('click',event=>{
    unlockSound();
    if(Date.now()-lastSwipe<300)return;
    const card=event.target.closest('.lr-hero-reel-card');
    if(!card)return;
    const index=Number(card.dataset.lrHeroReel);
    if(Number.isFinite(index)&&index!==active){active=index;render()}
  });

  carousel.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'){
      event.preventDefault();
      unlockSound();
      move(1);
    }else if(event.key==='ArrowLeft'){
      event.preventDefault();
      unlockSound();
      move(-1);
    }else if(event.key==='Enter'||event.key===' '){
      unlockSound();
      syncPlayback();
    }
  });

  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>{
      const entry=entries[0];
      heroVisible=Boolean(entry?.isIntersecting&&entry.intersectionRatio>=.5);
      syncPlayback();
    },{threshold:[0,.25,.5,.75,1]});
    observer.observe(host);
  }else{
    const updateVisibility=()=>{
      detectInitialVisibility();
      syncPlayback();
    };
    window.addEventListener('scroll',updateVisibility,{passive:true});
    window.addEventListener('resize',updateVisibility,{passive:true});
  }

  document.addEventListener('visibilitychange',()=>{
    if(document.hidden){
      videos.forEach(video=>{video.pause();video.muted=true});
    }else{
      detectInitialVisibility();
      syncPlayback();
    }
  });

  detectInitialVisibility();
  render();
}

const run=()=>init();
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run,{once:true}):run();
document.addEventListener('shopify:section:load',()=>setTimeout(run,0));
})();
